import { callPostApi } from '../apiCallerProxy';
import { performanceMetricDataApiFactory } from './performanceMetricDataApiFactory';

export const performanceMetricDataApi = performanceMetricDataApiFactory({ callPostApi });
